import { render, staticRenderFns } from "./ListaEmpleados.vue?vue&type=template&id=5f50545d&scoped=true&"
import script from "./ListaEmpleados.vue?vue&type=script&lang=js&"
export * from "./ListaEmpleados.vue?vue&type=script&lang=js&"
import style0 from "./ListaEmpleados.vue?vue&type=style&index=0&id=5f50545d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50545d",
  null
  
)

export default component.exports